module.exports = __webpack_public_path__ + "img/bodo-glimt.8e67e110.png";